export default __webpack_public_path__ + "c55c8d1eff6ab5a08640ff76387c7024.svg";